export const COLORS = {
    BLACK: '#000000',
    RED: '#F0353C',
    WHITE: '#FFFFFF',


    // --- Case Study Colors ---
    YELLOW: '#FFBF38',
    GREEN: '#007C79',
};

export const SIZES = {
    BREAK_LG: '1080px',
    BREAK_MD: '800px',
    BREAK_SM: '600px',

    PADDING_DESKTOP: '80px',
    PADDING_TABLET: '40px',
    PADDING_MOBILE: '20px',

    PROSE_WIDTH: '640px',
    CASE_STUDY_SECTION_SPACING: '3.75rem',
    TABLET_SECTION_SPACING: '80px',
    MOBILE_SECTION_SPACING: '60px',

    BORDER_RADIUS: '3px',
};


export const MISC = {
    BOX_SHADOW: '0px 4px 20px 0px rgba(0, 0, 0, 0.1)',
};